import { Card } from "@swot/base-components";
import { CmtsDependencyBlockerPanel } from "../CmtsDependencyBlockerPanel.js";
import type { CmtsMasterDataCrudEntityConfig } from "../../core/master-data/cmtsMasterDataCrudRegistry.js";
import type { DependencyCheckResult, EntityRecord } from "../../types/api.types.js";

function displayValue(value: unknown): string {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
}

export function CmtsMasterDataDependencyPanel(props: {
  readonly config: CmtsMasterDataCrudEntityConfig;
  readonly record?: EntityRecord | null | undefined;
  readonly dependencyCheck?: DependencyCheckResult | undefined;
}) {
  const dependencyTargets = props.config.dependencyTargets.length ? props.config.dependencyTargets.join(", ") : "No configured downstream dependency target";
  const dropdownConsumers = props.config.dropdownConsumers.length ? props.config.dropdownConsumers.join(", ") : "No configured dropdown consumer";
  return (
    <Card title="Dependency and dropdown impact" subtitle="Backend dependency check governs destructive actions before status changes are allowed.">
      <dl className="cmts-master-data-detail-list">
        <dt>Record</dt><dd>{displayValue(props.record?.label ?? props.record?.name ?? props.record?.code ?? props.record?.id)}</dd>
        <dt>Dependency targets</dt><dd>{dependencyTargets}</dd>
        <dt>Dropdown consumers</dt><dd>{dropdownConsumers}</dd>
      </dl>
      <CmtsDependencyBlockerPanel dependencyCheck={props.dependencyCheck} />
    </Card>
  );
}
